import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { PrototypeProvider } from './contexts/PrototypeContext';
import { ScrollManager } from './components/layout/ScrollManager';
import { SeasonBanner } from './components/layout/SeasonBanner';
import { SiteHeader } from './components/layout/SiteHeader';
import { SiteFooter } from './components/layout/SiteFooter';
import { ReviewTool } from './components/review/ReviewTool';
import { Home } from './pages/Home';
import { Contact } from './pages/Contact';
import { ContactThankYou } from './pages/ContactThankYou';
import { Cart } from './pages/Cart';
import { Checkout } from './pages/Checkout';
import { OrderConfirmation } from './pages/OrderConfirmation';
type SeasonTreatment = 'everyday' | 'black-friday' | 'christmas';
interface AppProps {
  season?: SeasonTreatment;
  showReviewTool?: boolean;
}
export function App({
  season = 'everyday',
  showReviewTool = true
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="23ti5fwt74ggi">
      <PrototypeProvider initialSeason={season} data-id="element-1" data-mp="3ikh8ubu2yx01">
        <ScrollManager data-id="element-2" data-mp="3ijpcgysnsv8p" />
        {/* #customer-canvas = the eventual customer site. Review tooling stays outside it. */}
        <div id="customer-canvas" style={{
        '--prototype-top-offset': showReviewTool ? '48px' : '0px'
      } as React.CSSProperties} className="flex min-h-screen w-full flex-col bg-canvas pt-[var(--prototype-top-offset)] text-ink md:pt-0" data-id="element-3" data-mp="3mj6jvxrnc2gi">
          <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-[3px] focus:bg-ink focus:px-4 focus:py-3 focus:text-canvas" data-id="element-4" data-mp="2zmo89g6xiz5t">
            Skip to content
          </a>
          <SeasonBanner data-id="element-5" data-mp="3dl4llpzarnwx" />
          <SiteHeader data-id="element-6" data-mp="3dmfqxu8e53q5" />
          <main id="main" className="flex-1" data-id="element-7" data-mp="3dirvgpjdy78s">
            <Routes data-id="element-8" data-mp="nwc0jp6vnpuo">
              <Route path="/" element={<Home data-id="element-10" data-mp="nxn71wrpjbph" />} data-id="element-9" data-mp="nuraocvicv35" />
              <Route path="/contact" element={<Contact data-id="element-12" data-mp="stkne32z0i29" />} data-id="element-11" data-mp="sudksdg1hv7q" />
              <Route path="/contact/thank-you" element={<ContactThankYou data-id="element-14" data-mp="3686tkdjumw2" />} data-id="element-13" data-mp="sssqmoxn0eae" />
              <Route path="/cart" element={<Cart data-id="element-16" data-mp="38kwkjpju1jo" />} data-id="element-15" data-mp="356sn718lka4" />
              <Route path="/checkout" element={<Checkout data-id="element-18" data-mp="3ubrfsfo6881v" />} data-id="element-17" data-mp="3uct0lbuzo8ws" />
              <Route path="/order-confirmation" element={<OrderConfirmation data-id="element-20" data-mp="d4e4tqw8j8vn" />} data-id="element-19" data-mp="3ucjcxuxf2du9" />
              <Route path="*" element={<Home data-id="element-22" data-mp="d2l9v8uzid3h" />} data-id="element-21" data-mp="d3cw3t2oyyh3" />
            </Routes>
          </main>
          <SiteFooter data-id="element-23" data-mp="86mev2f5hwu3" />
        </div>
        {showReviewTool && <ReviewTool data-id="element-24" data-mp="3gle7udba4tcj" />}
      </PrototypeProvider>
    </BrowserRouter>;
}